<nav id="menu-services" (keyup.escape)="close()" aria-label="Services Menu">
    <div id="services-header">
        <div id="services-header-icon">
            <span style="position: relative; width: 19px; height: 13px">
                <img
                    [ngSrc]="'assets/images/app-icons/transnetyx-icon.svg'"
                    fill
                    [alt]="'transnetyx' | translate"
                    id="transnetyx-icon" />
            </span>
        </div>
        <p>{{ 'toolbar.servicesPanel.header' | translate }}</p>
    </div>

    <a
        id="genetic-monitoring-link"
        tabindex="0"
        aria-label="Go to Genetic Monitoring"
        (click)="goToGeneticMonitoring(); logAction('genetic-monitoring')"
        (keyup.enter)="goToGeneticMonitoring(); logAction('genetic-monitoring')">
        <div>
            <span style="position: relative; width: 30px; height: 30px">
                <img
                    [ngSrc]="'assets/images/app-icons/genetic-monitoring-icon.svg'"
                    fill
                    id="genetic-monitoring-icon" />
            </span>
            <label for="genetic-monitoring-icon" id="genetic-monitoring-label">{{
                'toolbar.servicesPanel.geneticMonitoring' | translate
            }}</label>
        </div>
        <deco-icon [iconClass]="'fa-regular fa-arrow-up-right-from-square'"></deco-icon>
    </a>

    <a
        id="microbiome-link"
        tabindex="0"
        aria-label="Go to Microbiome"
        (click)="goToMicrobiome(); logAction('microbiome')"
        (keyup.enter)="goToMicrobiome(); logAction('microbiome')">
        <div>
            <span style="position: relative; width: 30px; height: 30px">
                <img [ngSrc]="'assets/images/app-icons/microbiome-icon.svg'" fill id="microbiome-icon" />
            </span>
            <label for="microbiome-icon" id="microbiome-label">{{
                'toolbar.servicesPanel.microbiome' | translate
            }}</label>
        </div>
        <deco-icon [iconClass]="'fa-regular fa-arrow-up-right-from-square'"></deco-icon>
    </a>

    <a
        id="colony-and-ami-link"
        tabindex="0"
        aria-label="Go to Colony+AMI"
        (click)="goToColony(); logAction('colony')"
        (keyup.enter)="goToColony(); logAction('colony')">
        <div>
            <span style="position: relative; width: 30px; height: 30px">
                <img [ngSrc]="'assets/images/app-icons/colony-icon.svg'" fill id="colony-and-ami-icon" />
            </span>
            <label for="colony-and-ami-icon" id="colony-and-ami-label">{{
                'toolbar.servicesPanel.colony' | translate
            }}</label>
        </div>
        <deco-icon [iconClass]="'fa-regular fa-arrow-up-right-from-square'"></deco-icon>
    </a>

    <a
        id="tissue-link"
        tabindex="0"
        aria-label="Go to Tissue"
        (click)="goToTissue(); logAction('tissue')"
        (keyup.enter)="goToTissue(); logAction('tissue')">
        <div>
            <span style="position: relative; width: 30px; height: 30px">
                <img [ngSrc]="'assets/images/app-icons/tissue-icon.svg'" fill id="tissue-icon" />
            </span>
            <label for="tissue-icon" id="tissue-label">{{ 'toolbar.servicesPanel.tissue' | translate }}</label>
        </div>
        <deco-icon [iconClass]="'fa-regular fa-arrow-up-right-from-square'"></deco-icon>
    </a>

    <a
        id="tag-center-link"
        tabindex="0"
        aria-label="Go to TAGCenter"
        (click)="goToTagCenter(); logAction('tag-center')"
        (keyup.enter)="goToTagCenter(); logAction('tag-center')">
        <div>
            <span style="position: relative; width: 30px; height: 30px">
                <img [ngSrc]="'assets/images/app-icons/tag-center-icon.svg'" fill id="tag-center-icon" />
            </span>
            <label for="tag-center-icon" id="tag-center-label">{{
                'toolbar.servicesPanel.tagCenter' | translate
            }}</label>
        </div>
        <deco-icon [iconClass]="'fa-regular fa-arrow-up-right-from-square'"></deco-icon>
    </a>
</nav>
